module.exports = __webpack_public_path__ + "static/media/Hero_image_new.353f76f7.png";